import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent, TranslatePipe } from '@softline/ui-core';
import { MARKED_OPTIONS, MarkdownComponent, provideMarkdown } from 'ngx-markdown';
import { chartCardFromToolResult } from '../../functions/chart-mapping';
import { ChatMessage } from '../../types/chat-message.type';
import { AiAgentChartCardComponent } from '../chart-card/chart-card.component';

/** One bubble's body: tool indicators, the answer, and any chartable result. */
@Component({
  selector: 'soft-ai-agent-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, IconComponent, MarkdownComponent, AiAgentChartCardComponent],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  providers: [
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: { gfm: true, breaks: true, pedantic: false },
      },
    }),
  ],
})
export class AiAgentMessageComponent {
  readonly message = input.required<ChatMessage>();

  /** One card per tool result that maps to a chart; the rest render nothing. */
  protected readonly cards = computed(() =>
    this.message()
      .toolCalls.map((call) => ({
        id: call.id,
        card: chartCardFromToolResult(call.name, call.result),
      }))
      .filter((entry): entry is { id: string; card: NonNullable<typeof entry.card> } =>
        entry.card !== null
      )
  );
}
